import { render } from "./salesOver.vue?vue&type=template&id=8d4e6ac2"
import script from "./salesOver.vue?vue&type=script&lang=js"
export * from "./salesOver.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__